import * as Sentry from '@sentry/nuxt'

Sentry.init({
  dsn: 'https://4af5e1fffbd5e62606db914bc4b716e4@o4511990845538304.ingest.de.sentry.io/4511990932570192',
  enabled: process.env.NODE_ENV === 'production'
})
